export interface ClipboardTable {
    headers?: string[] | undefined;
    cells: Array<Array<string | number | undefined>>;
}

const toRow = (items: Array<string | number | undefined>) => items.map((item) => `<td>${item ?? '-'}</td>`).join('');

const createTableElement = ({ headers, cells }: ClipboardTable) => {
    const table = document.createElement('table');
    const tableBody = document.createElement('tbody');
    const headerRow = document.createElement('tr');

    headerRow.innerHTML = toRow(headers ?? []);
    tableBody.appendChild(headerRow);

    for (const item of cells) {
        const row = document.createElement('tr');
        row.innerHTML = toRow(item);
        tableBody.appendChild(row);
    }

    table.appendChild(tableBody);
    return table;
};

export const createNestedTableElement = (tables: ClipboardTable[]) => {
    const tablesToCopy = tables.map(createTableElement);

    const table = document.createElement('table');
    const tableBody = document.createElement('tbody');

    for (const item of tablesToCopy) {
        const row = document.createElement('tr');
        const cell = document.createElement('td');
        cell.appendChild(item);
        row.appendChild(cell);
        tableBody.appendChild(row);
    }

    table.appendChild(tableBody);
    return table;
};

export const copyTablesToClipboard = async (tables: ClipboardTable[]) => {
    const tableToCopy = createNestedTableElement(tables);

    // add table to document in an invisible container, so the table is rendered and inner text is copied as a formatted table
    const container = document.createElement('div');
    container.style.height = '0px';
    container.style.overflow = 'hidden';

    container.appendChild(tableToCopy);
    document.body.appendChild(container);

    await navigator.clipboard.writeText(tableToCopy.innerText);

    document.body.removeChild(container);
};
